export default __webpack_public_path__ + "static/media/OpenEyesRingRing.36271eeb.png";